import axios from 'axios'

const client = axios.create({
    baseURL: '/api/TyC',
    json: true
})

export default {
    async execute(vue, method, resource, data) {
        return client({
            method,
            url: resource,
            data
        }).then(req => {
            if (req.data.error) {
                vue.$alert(req.data.error).then(() => {});
            }
            return req.data
        })
    },
    get(vue, id) {
        return this.execute(vue, 'get', `Get?id=${id}`)
    },
    post(vue, id) {
        return this.execute(vue, 'post', `Post?id=${id}`)
    },
    downloadVersion(vue, id){
        return this.execute(vue, 'get', `DownloadVersion?idVersion=${id}`)
    },
    consultarDocumentosAprobados(vue, data){ 
        const id = btoa(data);    
        return this.execute(vue, 'post', `ConsultarDocumentosAprobados?data=${id}`)
    },
    aprobarDocumentosLegalesAutomaticas(vue, data){
        const id = btoa(data);
        return this.execute(vue, 'post', `AprobarDocumentosLegalesAutomaticas?data=${id}`)
    },
    aprobarDocumentosLegalesCesantias(vue, data){
        const id = btoa(data);
        return this.execute(vue, 'post', `AprobarDocumentosLegalesCesantias?data=${id}`)
    }
}